import styled from 'styled-components'

export const Container = styled.div`
  box-shadow: ${ (props) =>
    props.isFlat ? '1px 2px 1px 0 rgba(0, 0, 0, 0.13)' : 'none' };
`
